export const toRem = (px: number) => `${px / 16}rem`
